import React, { FC } from 'react';

import { useDispatch, useSelector } from 'react-redux'
import { useFormikContext } from 'formik';

import { useFormularioContext } from 'view/component/Formulario/Formulario';
import { BotaoCancelar, BotaoSalvar } from 'view/component/Botao/BotoesComuns';

import { SolicitacaoCorrenteAction } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.action';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';
import { OperacaoFormularioCRUD } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';


interface SolicitacaoServicoPageFormularioFooterProps {
  className: string;
}


export const SolicitacaoServicoPageFormularioFooter: FC<SolicitacaoServicoPageFormularioFooterProps> = ({className}) => {
  const isVisualizar = useSelector(SolicitacaoCorrenteSelector.formulario.isVisualizar);

  if (isVisualizar) {
    return <></>
  }

  return <footer className={className}>
    <BotaoSalvar />
    <BotaoSolicitacaoCancelar />
  </footer>
}


const BotaoSolicitacaoCancelar: FC = () => {
  const {operacao} = useFormularioContext();
  const {resetForm} = useFormikContext();

  const dispatch = useDispatch();

  const cancelarFormulario = () => {
    resetForm();
    dispatch(SolicitacaoCorrenteAction.edicao.cancelar());
  }

  if (operacao === OperacaoFormularioCRUD.Atualizar) {
    return <BotaoCancelar onClick={cancelarFormulario} />
  } else {
    return <></>
  }
}